"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorFormat = void 0;
var ColorFormat;
(function (ColorFormat) {
    /** RGB - rgb(r,g,b). Ignores alpha */
    ColorFormat["rgb"] = "rgb";
    /** RGBA - rgba(r,g,b,a). Always includes alpha */
    ColorFormat["rgba"] = "rgba";
    /** Selects between rgb and rgba modes based on non-opaque alpha */
    ColorFormat["smartRgba"] = "smartRgba";
    /** HEX - ffffff */
    ColorFormat["hex6"] = "hex6";
    /** HEXA - ffffff00 */
    ColorFormat["hex8"] = "hex8";
    /** #HEX - #ffffff */
    ColorFormat["hashHex6"] = "hashHex6";
    /** #HEXA - #ffffff00 */
    ColorFormat["hashHex8"] = "hashHex8";
    /** Selects between hex and hexa modes based on non-opaque alpha */
    ColorFormat["smartHashHex"] = "smartHashHex";
    /** Selects between hex and hexa modes based on non-opaque alpha */
    ColorFormat["smartHex"] = "smartHex";
    /** HSL - hsl(h,s,l). Ignores alpha */
    ColorFormat["hsl"] = "hsl";
    /** HSLA - hsla(h,s,l,a). Always includes alpha */
    ColorFormat["hsla"] = "hsla";
    /** Selects between hsl and hsla modes based on non-opaque alpha */
    ColorFormat["smartHsla"] = "smartHsla";
    /** iOS UIColor created as UIColor(rgb: 0x000000).withAlphaComponent(0.5). Alpha component will be ommited if fully opaque */
    ColorFormat["smartUIColor"] = "smartUIColor";
})(ColorFormat = exports.ColorFormat || (exports.ColorFormat = {}));
